/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserHospitalChatSignature200Response
 */
export interface UpdateCurrentUserHospitalChatSignature200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCurrentUserHospitalChatSignature200Response
     */
    success?: boolean;
    /**
     * Saved signature (cleaned, single line)
     * @type {string}
     * @memberof UpdateCurrentUserHospitalChatSignature200Response
     */
    hospital_chat_signature?: string;
}

/**
 * Check if a given object implements the UpdateCurrentUserHospitalChatSignature200Response interface.
 */
export function instanceOfUpdateCurrentUserHospitalChatSignature200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateCurrentUserHospitalChatSignature200ResponseFromJSON(json: any): UpdateCurrentUserHospitalChatSignature200Response {
    return UpdateCurrentUserHospitalChatSignature200ResponseFromJSONTyped(json, false);
}

export function UpdateCurrentUserHospitalChatSignature200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserHospitalChatSignature200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
        'hospital_chat_signature': !exists(json, 'hospital_chat_signature') ? undefined : json['hospital_chat_signature'],
    };
}

export function UpdateCurrentUserHospitalChatSignature200ResponseToJSON(value?: UpdateCurrentUserHospitalChatSignature200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'hospital_chat_signature': value.hospital_chat_signature,
    };
}

